module.exports = __webpack_public_path__ + "img/15.0716582f.png";